var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoError(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9974 0.667969C3.94731 0.667969 0.664062 3.95121 0.664062 8.0013C0.664062 12.0514 3.94731 15.3346 7.9974 15.3346C12.0475 15.3346 15.3307 12.0514 15.3307 8.0013C15.3307 3.95121 12.0475 0.667969 7.9974 0.667969ZM8.66406 5.33464C8.66406 4.96645 8.36559 4.66797 7.9974 4.66797C7.62921 4.66797 7.33073 4.96645 7.33073 5.33464V8.0013C7.33073 8.36949 7.62921 8.66797 7.9974 8.66797C8.36559 8.66797 8.66406 8.36949 8.66406 8.0013V5.33464ZM7.9974 10.0013C7.62921 10.0013 7.33073 10.2998 7.33073 10.668C7.33073 11.0362 7.62921 11.3346 7.9974 11.3346H8.00406C8.37225 11.3346 8.67073 11.0362 8.67073 10.668C8.67073 10.2998 8.37225 10.0013 8.00406 10.0013H7.9974Z",
    fill: "#FB3234"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoError);
export default __webpack_public_path__ + "static/media/info-error.c4230e2c41b4269f8a864fe471cf79a1.svg";
export { ForwardRef as ReactComponent };